import { render } from "./Communities.vue?vue&type=template&id=c3e1da02&scoped=true"
import script from "./Communities.vue?vue&type=script&lang=js"
export * from "./Communities.vue?vue&type=script&lang=js"

import "./Communities.vue?vue&type=style&index=0&id=c3e1da02&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3e1da02"]])

export default __exports__